import { Injectable } from '@angular/core';
import {OrganizationTrophyData} from "../interfaces/organization-trophy-data";
import {OverlayService} from "../overlay/overlay.service";
import {TrophiesListComponent} from "../shared/organization-trophies-block/trophies-list/trophies-list.component";
import {
  OrganizationTrophiesOverlayHeaderComponent
} from "../shared/organization-trophies-block/organization-trophies-overlay-header/organization-trophies-overlay-header.component";
import {
  OrganizationTrophiesOverlayFooterComponent
} from "../shared/organization-trophies-block/organization-trophies-overlay-footer/organization-trophies-overlay-footer.component";
import {DataService} from "./data.service";
import {take} from "rxjs";
import {GameTrophyProgressEntry} from "../interfaces/backend/game-trophy-progress-entry";

@Injectable({
  providedIn: 'root'
})
export class TrophyService {

  constructor(
    private data: DataService,
    private overlay: OverlayService) { }

  async loadClassTrophies(classId: number): Promise<OrganizationTrophyData> {
    return new Promise((resolve, reject) => {

      this.data.getGameTrophyProgress(classId).pipe(take(1)).subscribe((response) => {
        // console.log(response);
        const mappedResponse = this.mapOrganizationTrophyServerResponse(response);
        resolve(mappedResponse);
      });
      setTimeout(() => {
        // const response = this.generateDummyServerResponse();
        // resolve(mappedResponse);
      }, 100)
    })
  }

  openTrophiesOverlay(classId: number): void {
    this.loadClassTrophies(classId).then((trophies) => {
      const totalTrophies = trophies.items.length;
      const completedTrophies = trophies.items.filter((el) => el.percentValue == 100).length;
      this.overlay.openWindowOverlay({
        theme: "game",
        componentMain: {
          component: TrophiesListComponent,
          data: {
            items: trophies.items
          }
        },
        componentHeader: {
          component: OrganizationTrophiesOverlayHeaderComponent,
          data: {
            completedTrophies: completedTrophies,
            totalTrophies: totalTrophies
          }
        },
        componentFooter: {
          component: OrganizationTrophiesOverlayFooterComponent,
          data: {}
        }
      })
    })
  }

  private mapOrganizationTrophyServerResponse(response: GameTrophyProgressEntry[] | false): OrganizationTrophyData {
    const organizationTrophyData: OrganizationTrophyData = {
      items: []
    }

    organizationTrophyData.items = (response || []).map((el) => {
      return {
        trophyId: parseInt(el.trophy.id),
        percentValue: el.percentValue
      }
    });


    return organizationTrophyData;
  }

}
